import React from 'react';

import {HighlightedText} from 'src/modules/entitlements/components/main-column';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';


import type {PresetItem} from 'src/openapi/admin/models/PresetItem';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    query: string,
    response: ServerResponse<PresetItem[]> | null,
};

export const PresetSuggestResult = ({busy, query, response, id}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (query.length < 2) {
        return (
            <div id={id} className="pd-s">
                The search query is less than the minimum allowed, continue typing...
            </div>
        );

    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(preset => (
                    <AutosuggestItem key={preset.id} value={preset}>
                        {itemProps => (
                            <div style={{width: 450}}>
                                <EllipsisTextHint title={preset.name}>
                                    {!itemProps.highlighted ? (
                                        <HighlightedText
                                            text={preset.name}
                                            highlightedText={query}
                                        />
                                    ) : preset.name}
                                </EllipsisTextHint>
                            </div>
                        )}
                    </AutosuggestItem>
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No results found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
